
/**
 *
 * Edit Form
 *
 */

import React, { useState } from 'react'
import PropTypes from "prop-types"
import EditForm from '../EditForm'
import DeleteForm from '../DeleteForm'
import { resolveColumns, set } from 'helpers/tools'


const EditFormatter = (props) => {
  
const { actionClassName,name,funcolumns, title, columns = {}, access = [], actions = {}, selectors = {}, record = {}, editBtnStyle = { marginRight: '15px' }, deleteBtnStyle = {}, formatterStyle, metaData, editButton, field } = props
     
    const { customDeleteBtn, customEditBtn } = field || {}
    
    const locationState=[]
    const [formRecord, setFormRecord] = useState(record || {})
    const fields = resolveColumns(columns, Object.assign({}, record, formRecord), metaData,locationState,funcolumns)
    let initialValues = set(fields, Object.assign({}, record, formRecord))

    if (record.loading) {
        return <p className="card-text placeholder-glow" style={{ display: 'flex' }}>
            <span className="placeholder col-2"></span>
            <span className="placeholder col-2" style={{ marginLeft: '25px' }}></span>
        </p>
    }

    return <div style={{ display: 'flex' }} className={actionClassName?actionClassName:''}>
        {editButton && access.includes('Edit') ?
            React.createElement(editButton, props) :
            access.includes('Edit') ? <EditForm
                {...props}
                name={name}
                key={`edit_${record._id}`}
                title={`Manage ${title}`}
                
                editFlag={name==='other_details'?true:false}
                formTitle={`Edit ${title}`}
                initialValues={initialValues}
                formatterStyle={formatterStyle}
                fields={fields.filter(_ => _.editRecord)}
                allFields={fields.filter(_ => _.updateRecords)}
                selectors={selectors}
                // onChange={(data) => setFormRecord(data)}
                submitBtnText="Update"
                actions={actions}
                onChange={(data,fieldValue) => {
                    if (data.hikeAmount && data.currentSalary && fieldValue==='hikeAmount') {
                      data.hikedSalary = parseInt(data.hikeAmount) + parseInt(data.currentSalary)
                      data.hikePer = ((data.hikeAmount / data.currentSalary) * 100).toFixed(2)

                    }
                    if (data.hikePer && data.currentSalary&& fieldValue==='hikePer') {
                      data.hikeAmount = (data.hikePer / 100) * data.currentSalary
                      data.hikedSalary = parseInt(data.hikeAmount) + parseInt(data.currentSalary)
                    }
                    setFormRecord(data)
                    initialValues=data                                 
                  }
                  }
                 onCancel={() => setFormRecord({})}
                onSubmit={() => setFormRecord({})}>
                {(openModal) => {
                     return customEditBtn ? React.createElement(customEditBtn, Object.assign({}, props, { openModal })) : (
                    <button
                        type="button"
                        onClick={openModal}
                        style={editBtnStyle}
                        className="btn btn-success edit-table-btn">
                        <i className="mdi mdi-pencil d-block font-size-16"></i>
                    </button>)}}
            </EditForm> : null}
            {access.includes('Delete') ? 
             <DeleteForm
             name={name}
                 key={`delete_${record._id}`}
                 title={`Delete ${title}`}
                 fields={fields.filter(_ => _.deleteRecord)}
                 formTitle={`Delete ${title}`}
                 keyID={record.emp_id}
                 id={record._id}
                 actions={actions}>
                 {(openDialog) => {
                     return customDeleteBtn ? React.createElement(customDeleteBtn, Object.assign({}, props, { openDialog })) : (
                         <button
                             onClick={openDialog}
                             type="button"
                             style={deleteBtnStyle}
                             className="btn btn-danger delete-table-btn">
                             <i className="mdi mdi-trash-can d-block font-size-16"></i>
                         </button>)
                 }}
             </DeleteForm> : null}

        {/* {access.includes('Delete') ? <DeleteForm
            key={`delete_${record._id}`}
            title={`Delete ${title}`}
            id={record._id}
            actions={actions}>
            {(openDialog) => {
                return customDeleteBtn ? React.createElement(customDeleteBtn, Object.assign({}, props, { openDialog })) : (
                    <button
                        onClick={openDialog}
                        type="button"
                        style={deleteBtnStyle}
                        className="btn btn-danger delete-table-btn">
                        <i className="mdi mdi-trash-can d-block font-size-16"></i>
                    </button>)
            }}
        </DeleteForm> : null} */}
    </div>
}

EditFormatter.propTypes = {
    title: PropTypes.string,
    columns: PropTypes.any,
    access: PropTypes.array,
    actions: PropTypes.object,
    selectors: PropTypes.object,
    record: PropTypes.object,
    editBtnStyle: PropTypes.object,
    deleteBtnStyle: PropTypes.object,
    formatterStyle: PropTypes.object,
    metaData: PropTypes.object,
    name: PropTypes.string,
    editButton: PropTypes.func,
    field: PropTypes.any,
     actionClassName: PropTypes.any,
     funcolumns:PropTypes.func
}

export default EditFormatter